import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=add9e686&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add9e686')) {
      api.createRecord('add9e686', component.options)
    } else {
      api.reload('add9e686', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=add9e686&", function () {
      api.rerender('add9e686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rzNufY87sO7B/JS/offershelp.vue"
export default component.exports